<div class="change-password-overlay">
  <div class="change-password-panel" (click)="$event.stopPropagation()">
    <div class="panel-header">
      <div class="header-content">
        <mat-icon class="header-icon">lock</mat-icon>
        <h2 class="modal-title">Change Password</h2>
      </div>
      <button class="close-btn" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <div class="panel-body">
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <div class="modal-cnt">
          <div class="form_field_wrapper">
            <input
              [type]="hideCurrentPassword ? 'password' : 'text'"
              name="oldPassword"
              required
              placeholder=" "
              class="form-control"
              [formControl]="oldPasswordControl"
              [class.ng-invalid]="changePasswordForm.get('oldPassword')?.invalid && changePasswordForm.get('oldPassword')?.touched"
              [class.ng-touched]="changePasswordForm.get('oldPassword')?.touched"
            />
            <label class="floating_label">Current Password *</label>
            <button
              type="button"
              class="toggle-password"
              (click)="hideCurrentPassword = !hideCurrentPassword"
            >
              {{ hideCurrentPassword ? 'Show' : 'Hide' }}
            </button>
            @if (changePasswordForm.get('oldPassword')?.hasError('required') && changePasswordForm.get('oldPassword')?.touched) {
              <div class="mat-error">
                {{ getErrorMessage("oldPassword", changePasswordForm) }}
              </div>
            }
          </div>

          <div class="form_field_wrapper">
            <input
              [type]="hideNewPassword ? 'password' : 'text'"
              name="newPassword"
              required
              placeholder=" "
              class="form-control"
              [formControl]="newPasswordControl"
              [class.ng-invalid]="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched"
              [class.ng-touched]="changePasswordForm.get('newPassword')?.touched"
            />
            <label class="floating_label">New Password *</label>
            <button
              type="button"
              class="toggle-password"
              (click)="hideNewPassword = !hideNewPassword"
            >
              {{ hideNewPassword ? 'Show' : 'Hide' }}
            </button>
            @if (changePasswordForm.get('newPassword')?.touched && changePasswordForm.get('newPassword')?.errors) {
              <div class="mat-error">
                {{ getErrorMessage("newPassword", changePasswordForm) }}
              </div>
            }
          </div>

          <div class="form_field_wrapper">
            <input
              [type]="hideConfirmPassword ? 'password' : 'text'"
              name="confirmPassword"
              required
              placeholder=" "
              class="form-control"
              [formControl]="confirmPasswordControl"
              [class.ng-invalid]="(changePasswordForm.get('confirmPassword')?.invalid || changePasswordForm.errors?.['mismatch']) && (changePasswordForm.get('confirmPassword')?.touched || changePasswordForm.get('newPassword')?.touched)"
              [class.ng-touched]="changePasswordForm.get('confirmPassword')?.touched"
            />
            <label class="floating_label">Confirm Password *</label>
            <button
              type="button"
              class="toggle-password"
              (click)="hideConfirmPassword = !hideConfirmPassword"
            >
              {{ hideConfirmPassword ? 'Show' : 'Hide' }}
            </button>
            @if ((changePasswordForm.get('confirmPassword')?.touched && changePasswordForm.get('confirmPassword')?.errors) || (changePasswordForm.errors?.['mismatch'] && (changePasswordForm.get('confirmPassword')?.touched || changePasswordForm.get('newPassword')?.touched))) {
              <div class="mat-error">
                {{ getErrorMessage("confirmPassword", changePasswordForm) }}
              </div>
            }
          </div>
        </div><div class="form-actions">
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="changePasswordForm.invalid || loading()"
      >
        @if (loading()) {
          <app-spinner [size]="16" class="button-spinner"></app-spinner>
          Saving...
        } @else {
          Save
        }
      </button>
      <button
        class="btn-cancel"
        mat-stroked-button
        type="button"
        (click)="onCancel()"
      >
        Cancel
      </button>
    </div>
      </form>
    </div>
    
  </div>
</div>
